/* línkè · 珠串数据层（2026-07-19）==============================
   GET /api/pearls：克克（CC）上下文抱不动时的自动压缩摘要——
   「日子凝成的珠子」。大脑只读旁路从他的会话账本捞出，
   时间倒序、带全文；每颗带压缩前 token 数（珠子的重量）
   和 span_start（这颗裹着从哪天起的日子）。
   ============================================================== */

export async function loadPearls(refresh = false) {
  const res = await fetch('/api/pearls' + (refresh ? '?refresh=1' : ''), {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  const data = await res.json();
  return {
    total: Number(data.total) || 0,
    pearls: Array.isArray(data.pearls) ? data.pearls : [],
  };
}
